/**
 * Format price with currency symbol
 */
export const formatPrice = (price, currency = "EUR", exchangeRates = { EUR: 1 }) => {
  const numericPrice = Number(price) || 0;
  const rate = currency === "EUR" ? 1 : Number(exchangeRates?.[currency] || 1);
  const convertedPrice = numericPrice * rate;

  return new Intl.NumberFormat("en-IE", {
    style: "currency",
    currency,
  }).format(convertedPrice);
};

/**
 * Format date
 */
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-IE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

/**
 * Generate unique order number
 */
export const generateOrderNumber = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const random = Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, "0");
  return `TAB-${year}${month}${day}-${random}`;
};

/**
 * Validate email format
 */
export const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

/**
 * Parse CSV file
 */
export const parseCSV = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const lines = text.split("\n");
      const headers = lines[0].split(",").map((h) => h.trim());

      const data = lines
        .slice(1)
        .filter((line) => line.trim())
        .map((line) => {
          const values = line.split(",").map((v) => v.trim());
          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = values[index];
          });
          return obj;
        });

      resolve({ headers, data });
    };
    reader.onerror = reject;
    reader.readAsText(file);
  });
};
